<script setup>
import { computed } from 'vue';

import Button from '@/components/ds/Button.vue';

const props = defineProps({
  page: { type: Number, required: true },
  total: { type: Number, required: true },
  pageSize: { type: Number, default: 10 },
  label: { type: String, required: true },
});
defineEmits(['update:page']);
const pages = computed(() => Math.max(1, Math.ceil(props.total / props.pageSize)));
</script>

<template>
  <nav
    v-if="total > 0"
    class="list-pager"
    :aria-label="label"
  >
    <span
      class="list-pager__range"
      role="status"
    >
      {{ (page - 1) * pageSize + 1 }}–{{ Math.min(page * pageSize, total) }} of {{ total }}
    </span>
    <div
      v-if="pages > 1"
      class="list-pager__actions"
    >
      <Button
        size="sm"
        variant="secondary"
        icon-left="chevLeft"
        :disabled="page === 1"
        @click="$emit('update:page', page - 1)"
      >
        Previous
      </Button>
      <span class="list-pager__range">{{ page }} / {{ pages }}</span>
      <Button
        size="sm"
        variant="secondary"
        icon-right="chevRight"
        :disabled="page === pages"
        @click="$emit('update:page', page + 1)"
      >
        Next
      </Button>
    </div>
  </nav>
</template>

<style scoped>
.list-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-top: var(--space-4);
}

.list-pager__range {
  font-size: var(--text-xs);
  color: var(--fg-secondary);
  font-variant-numeric: tabular-nums;
}

.list-pager__actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
</style>
